/*
 *  Links List - Create a list of links, and then share it!
 *  Copyright (c) 2020 Luke Denton
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation; either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import Analytics from "@utils/Analytics";

export default {
  name: "ListOptions",
  data() {
    return {
      isVisible: false,
      listPermission: this.$store.getters.permissionState,
      originalPermission: this.$store.getters.permissionState
    }
  },
  methods: {
    handleSaveListPermission() {
      this.originalPermission = this.listPermission; // Allows for undoing a change if a user clicks on cancel in the modal
      this.$store.dispatch('setListPermission', { permission: this.listPermission })
      this.$store.dispatch('syncToFirebase');
      this.isVisible = false;
      Analytics.FireFeatureUsed('list_permission', this.listPermission);
    },
    handleCancelPermissionChange() {
      this.listPermission = this.originalPermission; // Undo any changes to the modal value
      this.isVisible = false;
    }
  }
};
